import SmileIcon from '@shared/assets/icons/v2/smile.svg';
import { AnchoredSheet } from '@shared/components/AnchoredSheet';
import { View } from '@shared/components/View';
import { MBEmojiPicker } from '@shared/components/form';
import { MBTouchableIcon } from '@shared/components/touchable';
import { Colors } from '@shared/styles';
import { useBoolean, useIsDesktop } from '@shared/util/hooks';
import styles from './emojiButton.module.css';
import { Styles } from './styles';

interface Props {
  onSelect(emoji: string): void;
}

export function MBEmojiButton({ onSelect }: Props) {
  const isDesktop = useIsDesktop();
  const [showPicker, showPickerOn, showPickerOff] = useBoolean(false);

  if (!isDesktop) {
    return null;
  }
  return (
    <>
      <View style={{ anchorName: '--chat-emoji-button', ...Styles.alignBottom }}>
        <MBTouchableIcon
          source={SmileIcon}
          color={Colors.v2.purple}
          noPadding
          style={{ width: 40, height: 40 }}
          onPress={showPickerOn}
        />
      </View>
      {showPicker && (
        <AnchoredSheet
          anchorName="--chat-emoji-button"
          onClose={showPickerOff}
          className={styles.picker}
        >
          <MBEmojiPicker onSelect={onSelect} />
        </AnchoredSheet>
      )}
    </>
  );
}
